import request from '../request';
import {RequestReturnPromise} from './type';
import {UserState} from '../store/user';

export type LoginParams = {
  mobile: string;
  deviceSn: string;
  password: string;
};

/**
 * @param {Object} data
 * @param {string} data.mobile
 * @param {string} data.deviceSn
 * @param {string} data.password
 * @returns {Promise}
 */
// @ts-ignore
export function loginApi(
  data: LoginParams,
): RequestReturnPromise<UserState['userInfo']> {
  return request({
    method: 'post',
    url: '/api-internet-user/ai-web-user/login',
    data,
  });
}

export type SendCodParams = {
  mobile: string;
  redeemCode: string;
};

// @ts-ignore
export function sendCodeApi(data: SendCodParams): RequestReturnPromise<any> {
  return request({
    method: 'post',
    url: '/api-internet-user/ai-web-user/login/register/sms',
    data,
  });
}

// /api-internet-user/ai-user/login/register
// @ts-ignore
export function registerApi(data) {
  return request({
    method: 'post',
    url: '/api-internet-user/ai-web-user/login/register',
    data,
  });
}

export function updateUserApi(
  data: Partial<UserState['userInfo']>,
): RequestReturnPromise<UserState['userInfo']> {
  return request({
    method: 'post',
    url: '/api-internet-user/mp/ai/user/modify',
    data,
  });
}

export function updateAvatarApi(data: {
  file: string;
  userId?: number;
  deviceSn: string;
}): RequestReturnPromise<UserState['userInfo']> {
  return request({
    method: 'post',
    url: '/api-internet-user/mp/ai/user/upload/avatar',
    data,
  });
}

// 忘记密码获取验证码 /api-internet-user/ai-user/login/password/sms
export function forgetCodeApi(data: {
  mobile: string;
}): RequestReturnPromise<any> {
  return request({
    method: 'post',
    url: '/api-internet-user/ai-user/login/password/sms',
    data,
  });
}

// 确认修改密码 /api-internet-user/ai-user/login/password
// @ts-ignore
export function forgetPasswordApi(data) {
  return request({
    method: 'post',
    url: '/api-internet-user/ai-user/login/password',
    data,
  });
}

export type LogonListInfo = {
  id: number;
  gender: number;
  name: string;
  mobile: string;
  avatar: string;
};

export function getLogonList(): RequestReturnPromise<LogonListInfo[]> {
  return request({
    url: '/api-internet-user/mp/ai/user/device/logon/list',
  });
}

// 注销账号
export function logoffApi(): RequestReturnPromise<any> {
  return request({
    method: 'post',
    url: '/api-internet-user/mp/ai/user/logoff',
  });
}

export function checkSN(deviceSn: string): RequestReturnPromise<any> {
  return request({
    method: 'post',
    url: '/api-internet-user/ai-user/login/checkSn',
    data: {
      deviceSn: deviceSn,
    },
  });
}

// 兑换码兑换
export function ActivateRedeemCode(data: {
  redeemCode: string;
  mobile: string;
}): RequestReturnPromise<any> {
  return request({
    method: 'post',
    url: '/api-internet-user/mp/ai/user/web/activate/redeemCode',
    data,
  });
}
